let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("zNNA3")).then(() => parcelRequire('hlhZ3'));